import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
  SuiModal,
  SuiModalService,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
} from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { CompanyService, OrganizationService } from '../../services';

import { YearRecordModal } from '../year-record-modal/year-record-modal.component';
interface INewTccRecordModalContext {
  data: any;
  title?: string;
  isEdit?: boolean;
}
@Component({
  selector: 'app-new-tcc-record-modal',
  templateUrl: './new-tcc-record-modal.component.html',
  styleUrls: ['./new-tcc-record-modal.component.scss'],
})
export class NewTccRecordModalComponent implements OnInit, OnDestroy {
  searchable: boolean = true;
  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  organizationDetails;
  companyTccForm: FormGroup;
  companyTcc: any;
  organizationId: string;
  currentForm: FormGroup;
  companyTypes;
  isBusinessName: boolean = false;
  constructor(
    private companySvc: CompanyService,
    private modalService: SuiModalService,
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    private organizationSvc: OrganizationService,
    public modal: SuiModal<INewTccRecordModalContext, void, void>
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.organizationDetails = JSON.parse(
      window.localStorage.getItem('organization')
    );
    this.companyTypes =
      this.organizationDetails?.jpaContractor?.companyType?.optionId;
    this.getCompanyType();
    this.companyTccForm = fb.group({
      taxPayerName: [''],
      organizationTccId: [''],
      tccIssueDate: [''],
      tccExpiryDate: [''],
      taxOffice: [''],
      tccNumber: ['', Validators.required],
    });
    if (modal.context.isEdit) {
      this.companyTcc = modal.context.data;
      this.companyTccForm.patchValue(modal.context.data);
    }
    this.currentForm = this.companyTccForm;
  }
  isFieldValid(field: string) {
    return (
      (!this.companyTccForm.get(field).valid &&
        this.companyTccForm.get(field).touched) ||
      (this.companyTccForm.get(field).untouched && this.formSubmitAttempt)
    );
  }
  getCompanyType() {
    console.log(
      this.companyTypes,
      this.organizationDetails?.jpaContractor?.tinNumber,
      'newtome'
    );
    if (
      (this.companyTypes === 'business_name_actual' ||
        this.companyTypes === 'business_name') &&
      this.organizationDetails?.jpaContractor?.tinNumber === null
    ) {
      this.isBusinessName = true;
    }
  }
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  submit() {
    this.modal.context.isEdit == true ? this.update() : this.save();
  }

  save() {
    this.formSubmitAttempt = false;
    if (this.companyTccForm.valid) {
      this.pending = true;
      // this.companySvc
      //   .getCompanyTCC({
      //     organizationId: this.organizationId,
      //     tccNumber: this.companyTccForm.value.tccNumber,
      //   })
      //   .subscribe(
      //     (res) => {
      this.companySvc
        .addCompanyTcc({
          tccNumber: this.companyTccForm.value.tccNumber,
          organizationId: this.organizationId,
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company TCC record added successfully.';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error.message
              ? error.error.message
              : error.error
              ? error.error
              : error;
          }
        );
      // },
      // (error) => {
      //   this.pending = false;
      //   console.log(error);
      //   this.error = error.error.message
      //     ? error.error.message
      //     : error.error.text
      //     ? error.error.text
      //     : error;
      // }
      // );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  update() {
    this.formSubmitAttempt = false;
    if (this.companyTccForm.valid) {
      this.pending = true;
      this.companySvc
        .updateCompanyEquipment({
          id: this.companyTcc.organizationEquipmentId,
          body: { ...this.companyTcc, ...this.companyTccForm.value },
        })
        .subscribe(
          (res) => {
            this.pending = false;
            this.success = 'Company Tcc updated successfully.';
            setTimeout(() => {
              this.modal.approve(null);
            }, 2000);
          },
          (error) => {
            this.pending = false;
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  nullify() {
    this.success = null;
    this.error = null;
  }
  ngOnInit() {
    // this.document.body.classList.remove('panel');
  }
  // s
  ngOnDestroy(): void {
    // this.document.body.classList.add('panel');
  }

  yearRecord() {
    this.modalService
      .open(
        new YearRecordModal(
          'Year Records',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }
}

export class NewTccRecordModal extends ComponentModalConfig<
  INewTccRecordModalContext,
  void,
  void
> {
  constructor(title: string, data: string, size: ModalSize = ModalSize.Tiny) {
    super(NewTccRecordModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
